/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018-2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { connect } from 'react-redux';
import {
  IntlConfigSelectors,
  UserPreferencesSelectors,
  UserPreferencesActions,
} from '@spm/universal-access';
import LanguageDropdownComponent from './components/LanguageDropdownComponent';

const mapStateToProps = state => ({
  language: UserPreferencesSelectors.getUserSelectedLanguage(state),
  locales: IntlConfigSelectors.getLocales(state),
});

export const mapDispatchToProps = dispatch => ({
  onLanguageToggle: value => UserPreferencesActions.changeLanguage(dispatch, value),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageDropdownComponent);
